module.exports = __webpack_public_path__ + "img/cheese.4076a8a4.svg";